<template>
    <div class="resumen-proyecto">
      <div v-for="(evento, index) in cronologia" :key="index" class="evento mb-4">
        <!-- Información del Evento -->
        <h4 class="evento-titulo d-flex justify-content-between align-items-center">
          <div>
            <font-awesome-icon :icon="['fas', 'calendar-alt']" class="me-2" /> {{ evento.nombre_evento }}
          </div>
          <button 
            class="btn btn-sm btn-outline-secondary" 
            @click="toggleCollapse(index)"
          >
            {{ isCollapsed(index) ? 'Mostrar Detalles' : 'Ocultar Detalles' }}
          </button>
        </h4>
        <p>
          <strong>Fecha del Evento:</strong> {{ formatDate(evento.fecha_evento) }} &nbsp;|&nbsp; 
          <strong>Costo Estimado:</strong> {{ formatCurrency(evento.costo_estimado) }} &nbsp;|&nbsp; 
          <strong>Estado:</strong> 
          <span :class="evento.finalizado ? 'text-success' : 'text-warning'">
            {{ evento.finalizado ? 'Finalizado' : 'En Proceso' }}
          </span>
        </p>
  
        <div v-show="!isCollapsed(index)">
          <!-- Estadísticas del Evento -->
          <div class="evento-stats">
            <p><strong>Total de Horas:</strong> {{ evento.estadisticas.total_horas }} horas</p>
            <p><strong>Costo Total:</strong> {{ formatCurrency(evento.estadisticas.total_costo) }}</p>
            <h6>Ítems Más Usados:</h6>
            <ul v-if="evento.estadisticas.items_mas_usados.length">
              <li v-for="(item, itemIndex) in evento.estadisticas.items_mas_usados" :key="itemIndex">
                {{ item.nombre }} - Cantidad: {{ item.cantidad }} - Costo: {{ formatCurrency(item.costo) }}
              </li>
            </ul>
            <p v-else class="text-muted">No se usaron ítems en este evento.</p>
          </div>
  
          <!-- Información de Tareas -->
          <h5 class="mt-3">Tareas del Evento:</h5>
          <ul v-if="evento.tareas.length" class="tareas-list">
            <li v-for="(tarea, tareaIndex) in evento.tareas" :key="tareaIndex" class="tarea-item">
              <div class="d-flex justify-content-between align-items-center">
                <strong>{{ tarea.nombre_tarea }}</strong>
                <small class="text-muted">{{ formatDate(tarea.fecha_creacion_tarea) }}</small>
              </div>
              <p class="mb-1">
                <strong>Objeto/Objetivo:</strong> {{ tarea.objeto_objetivo }}
              </p>
              <p class="mb-1">
                <strong>Costo:</strong> {{ formatCurrency(tarea.costo) }} &nbsp;|&nbsp; 
                <strong>Duración:</strong> {{ tarea.duracion_horas }} horas
              </p>
              <p v-if="tarea.cumpli_grupo || tarea.cumpli_etiqueta" class="mb-1">
                <strong>Cumplimiento Grupo:</strong> {{ tarea.cumpli_grupo || 'N/A' }} &nbsp;|&nbsp; 
                <strong>Cumplimiento Etiqueta:</strong> {{ tarea.cumpli_etiqueta || 'N/A' }}
              </p>
  
              <!-- Items Usados -->
              <div v-if="tarea.items_usados.length" class="items-usados">
                <h6>Items Usados:</h6>
                <ul>
                  <li v-for="(item, itemIndex) in tarea.items_usados" :key="itemIndex">
                    {{ item.nombre }} - Cantidad: {{ item.cantidad }} - Costo: {{ formatCurrency(item.costo) }}
                  </li>
                </ul>
              </div>
              <p v-else class="text-muted">No se usaron ítems.</p>
              <!-- personal asignado -->
              <div v-if="tarea.personal_asignado?.length" class="mt-2">
                <h6>Personal Participante:</h6>
                <ul class="personal-list">
                  <li v-for="personal in tarea.personal_asignado" :key="personal.id">
                    {{ personal.nombre }} {{ personal.apellido }}
                  </li>
                </ul>
              </div>


            </li>
          </ul>
          <p v-else class="text-muted">No hay tareas asociadas a este evento.</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      cronologia: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        collapsedIndexes: new Set(),
      };
    },
    methods: {
      formatDate(date) {
        return new Date(date).toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        });
      },
      formatCurrency(value) {
        return new Intl.NumberFormat('es-ES', {
          style: 'currency',
          currency: 'USD',
        }).format(value);
      },
      toggleCollapse(index) {
        if (this.collapsedIndexes.has(index)) {
          this.collapsedIndexes.delete(index);
        } else {
          this.collapsedIndexes.add(index);
        }
      },
      isCollapsed(index) {
        return this.collapsedIndexes.has(index);
      },
    },
  };
  </script>
  
  <style scoped>
  .resumen-proyecto {
    padding: 1.5rem;
    background-color: #f8f9fa;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  .evento {
    border-bottom: 1px solid #ddd;
    padding-bottom: 1rem;
  }
  .evento-titulo {
    color: var(--app-primary);
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  .tareas-list {
    list-style: none;
    padding-left: 0;
  }
  .tarea-item {
    background-color: #fff;
    border: 1px solid #e3e3e3;
    padding: 0.75rem;
    margin-bottom: 0.5rem;
    border-radius: 5px;
  }
  .items-usados ul {
    padding-left: 1rem;
  }
  .text-muted {
    font-size: 0.85rem;
  }
  .text-success {
    color: #28a745;
  }
  .text-warning {
    color: #ffc107;
  }
  </style>
  